<main role="main">
  @if (!loading) {
<router-outlet></router-outlet>
} @else {

    <app-loader></app-loader>
  
}
  
</main>
@if (sharedService.globalComments.showComments) {
<div class="comment-backdrop"></div>
}
@if (sharedService.globalComments.showComments) {
<div class="comments-section">
    <div class="comments-container" #commentsPopup>
        <app-shared-comments [moduleId]="sharedService.globalComments.moduleId" [module]="sharedService.globalComments.module"
            (onClose)="onCommentsClose($event)"></app-shared-comments>
    </div>
</div>
}
